import ModifierViewModel from './ModifierViewModel'

const ModifierGroupViewModel = (modifierGroup) => {
  return ModifierViewModel(modifierGroup)
}

export default ModifierGroupViewModel
